import { TableBody as MuiTableBody, TableCell, TableRow } from "@mui/material";
import type { Row, RowData } from "@tanstack/react-table";
import { flexRender } from "@tanstack/react-table";
import { memo } from "react";

import { ACTION_COLUMN_ID, ROW_NUMBER_COLUMN_ID } from "./constants";

interface Props<TData extends RowData> {
    rows: Row<TData>[];
    rowBackgroundColor?: (row: Row<TData>["original"]) => string | undefined;
}

export const TableBody = memo(function TableBody<TData extends RowData>({ rows, rowBackgroundColor }: Props<TData>) {
    return (
        <MuiTableBody>
            {rows.map((row) => {
                const customBackgroundColor = rowBackgroundColor?.(row.original);
                return (
                    <TableRow
                        key={row.id}
                        hover
                        sx={{
                            backgroundColor: customBackgroundColor || "transparent",
                            ".MuiTableRow-hover": {
                                backgroundColor: customBackgroundColor ? customBackgroundColor : "#eef3fd",
                            },
                        }}
                    >
                        {row.getVisibleCells().map((cell) => (
                            <TableCell
                                key={cell.id}
                                sx={{
                                    padding: "0px",
                                    width: cell.column.getSize(),
                                    textAlign: "center",
                                    borderBottom: "1px solid #e0e0e0",
                                    borderRight: "1px solid #e0e0e0",
                                    "&:last-child": {
                                        borderRight: 0,
                                    },
                                    height: cell.column.id === ACTION_COLUMN_ID ? `${cell.column.getSize()}px` : "50px",
                                    verticalAlign: "middle",
                                    backgroundColor:
                                        customBackgroundColor ??
                                        (cell.column.id === ACTION_COLUMN_ID || cell.column.id === ROW_NUMBER_COLUMN_ID
                                            ? "#F6F6F6"
                                            : "transparent"),
                                    fontWeight:
                                        customBackgroundColor ??
                                        (cell.column.id === ACTION_COLUMN_ID || cell.column.id === ROW_NUMBER_COLUMN_ID
                                            ? "bold"
                                            : "normal"),
                                }}
                            >
                                {flexRender(cell.column.columnDef.cell, cell.getContext())}
                            </TableCell>
                        ))}
                    </TableRow>
                );
            })}
        </MuiTableBody>
    );
});
